import FormInputAsyncSelect from './FormInputAsyncSelect';

import { SelectStyles as styles } from './styles';

export const SelectStyles = styles;
export default FormInputAsyncSelect;
